export default "<span class=\"icon-container\">\r\n  <img [src]=\"imagePath\" alt=\"\">\r\n  <span class=\"icon-quantity\">{{percent}}%</span>\r\n</span>\r\n";